import { useEffect } from 'react';
import { RefundProps } from '../types';
import { useCashApi } from '~Components/CashUniverse';
import { useCashDrawer } from '~Providers/CashDrawerProvider';

export const RefundCash = (props: RefundProps) => {
  const { onCompleted } = props;

  const cashDrawer = useCashDrawer();
  const cashApi = useCashApi();

  useEffect(() => {
    onCompleted();

    cashDrawer.open();
    cashApi.updateCash(-props.amount);
  }, []);

  return null;
};
